/* eslint-disable */
import React from 'react';

const IconClock = () => (
    <svg version="1.1"
         id="clock"
         xmlns="http://www.w3.org/2000/svg"
         x="0px"
         y="0px"
         viewBox="0 0 490.667 490.667">
        <g>
            <path fill="currentColor" d="M245.333,0C110.059,0,0,110.059,0,245.333s110.059,245.333,245.333,245.333s245.333-110.059,245.333-245.333
            S380.608,0,245.333,0z M245.333,469.333c-123.52,0-224-100.48-224-224s100.48-224,224-224s224,100.48,224,224
            S368.853,469.333,245.333,469.333z"/>
        </g>
        <g>
            <path fill="currentColor" d="M348.885,333.803L256,240.917V74.667C256,68.779,251.221,64,245.333,64s-10.667,4.779-10.667,10.667v170.667
          c0,2.837,1.131,5.547,3.115,7.552l96,96c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.552-3.115
          C353.045,344.725,353.045,337.963,348.885,333.803z"/>
        </g>
    </svg>

);

export default IconClock;




